// Published legal package. The markdown files beside this module are copied
// byte-for-byte from the canonical legal source; LEGAL_HASH is the SHA-256 of
// the normalized Terms + Privacy package and is re-verified in
// src/test/legal-content.test.ts.
export const LEGAL_VERSION = "2026-10-01.1";
export const LEGAL_UPDATED = `October 1, 2026 · Version ${LEGAL_VERSION}`;
export const LEGAL_HASH = "c27e72e3293bfc7eb34a51815e5a50627a3df916031649a66905cae5856ddb8e";
